import type { Lang } from '../../lib/i18n';
import { workoutStrings } from '../../lib/tools';
import { generatePlan } from '../../lib/workoutGenerator';
import { ToolLanding } from '../../components/tools/ToolLanding';
import { EXAMPLE_INPUTS, PlanView, WORKOUT_SLUG, WorkoutGenerator } from '../../components/tools/WorkoutGenerator';

export default function WorkoutGeneratorPage({ lang = 'en' as Lang }: { lang?: Lang }) {
  const t = workoutStrings(lang);
  const example = generatePlan(EXAMPLE_INPUTS, lang);
  return (
    <ToolLanding
      lang={lang}
      slug={WORKOUT_SLUG}
      copy={t}
      embedHeight={1400}
      tool={<WorkoutGenerator lang={lang} />}
      example={
        <section className="mb-14" aria-labelledby="example-heading">
          <h2 id="example-heading" className="text-2xl md:text-3xl font-extrabold text-ink mb-2">{t.example.heading}</h2>
          <p className="text-muted mb-5">{t.example.intro}</p>
          <PlanView plan={example} lang={lang} headingLevel="h3" showNotes={false} />
        </section>
      }
    />
  );
}
